import { loadStripe } from "@stripe/stripe-js";

// Singleton promise — loadStripe is only called once across all billing components.
let stripePromise = null;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.VUE_APP_STRIPE_LIVE);
  }
  return stripePromise;
}
